// == 基礎設定檔 == //
export const Config = {
  VERSION : '2023.09.25.1',  //版本號
  DefaultLang: 'zh_TW', //預設語系
  rootUrl:'https://isourcing.taiwantrade.com/',
  localUrl : 'https://isourcing.taiwantrade.com/api/',
  // rootUrl:'https://isourcingbeta.perfect.tw/',
  // localUrl : 'https://isourcingbeta.perfect.tw/api/',
  releaseUrl : '/',
  DebugMode : true,
  DebugLogin: '', //eoda@hyweb.com.tw,perfect@gmail.com,winnie@perfect.tw
  Search:[
    {
      name:'採購案報名狀態',
      value:0,
      SecMenu:[
        {name:'尚未開放',value:'0'},
        {name:'開放報名',value:'1'},
        {name:'候補報名',value:'2'},
        {name:'已額滿',value:'3'},
        {name:'報名截止',value:'4'},
        {name:'已舉辦',value:'9'}
      ]
    },
    {
      name:'產業',
      value:1,
      SecMenu:[]
    },
    {
      name:'採購案類型',
      value:2,
      SecMenu:[
        //{name:'全部',value:''},
        //{name:'展覽洽談',value:'1'},
        {name:'來台採購',value:'2'},
        // {name:'海外自辦',value:'3'},
        {name:'視訊洽談',value:'4'}
      ]
    },
    {
      name:'買主所在地',
      value:3,
      SecMenu:[]
    },
    {
      name:'買主公司',
      value:4,
      SecMenu:[]
    },
    {
      name:'採購品項',
      value:5,
      SecMenu:[]
    },
    {
      name:'買主預約狀態',
      value:6,
      SecMenu:[
        {name:'可報名',value:'1'},
        {name:'已額滿',value:'2'},
        {name:'買主取消',value:'3'},
        // {name:'報名截止',value:'4'},
        // {name:'尚未開始報名',value:'5'},
        // {name:'已報名',value:'6'}
      ]
    },
  ],
  eventType : {
    // 1:{name:'展覽洽談'},
    2:{name:'來台採購'},
    3:{name:'海外自辦'},
    4:{name:'視訊洽談'}
  },
  enrollStatus : {
    0:{class:'end',name:'尚未開放'},
    1:{class:'online',name:'開放報名'},
    2:{class:'standby',name:'候補報名'},
    3:{class:'deadline',name:'已額滿'},
    4:{class:'end',name:'報名截止'},
    9:{class:'end',name:'已舉辦'}
  },
  buyerStatus : {
    0:{class:'cancel',name:'未設定'},
    1:{class:'valid',name:'可報名'},
    2:{class:'full',name:'已額滿'},
    3:{class:'cancel',name:'買主取消'},
    4:{class:'deadline',name:'報名截止'},
    5:{class:'cancel',name:'尚未開始報名'},
    8:{class:'regist',name:'已報名'}
  }
}
